//============================
//# Interfész típusok (csisyncifacetyp)
//============================

export enum IfaceType {
    /** Technikai rekord */
    None = 1,
    /** Cikk */
    Part = 2,
    /** Partner (szállító/vevő) */
    Partner = 3,
    /** Gépjármű */
    Car = 4,
    /** Kimenő számla */
    OutInvoice = 5,
    /** Interfész nélkül */
    NoInterface = 6,
    /** Bejövő számla */
    InInvoice = 7,
    /** Költséghely */
    CostCenter = 8,
    /** Tax Code */
    TaxCode = 9,
    /** Fizetési mód */
    PaymentMode = 10,
}
